<template>

  <!-- Courses Admin Start -->
  <div class="section overflow-hidden position-relative" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">
      <div class="container-fluid">

        <!-- Graph Top Start -->
        <div class="graph">
          <div v-if="test == 'mock'" class="admin-courses-tab-content">
            <div class="tab-content">
              <div class="tab-pane fade show active" id="tab1">

                <div class="padding-top-50">

                  <p class="question">You are about to start a Final test!</p>
                  <p class="question">Please read the information below carefully before clicking start button - </p>

                  <ol class="test-instructions">
                    <li>1. Ensure you have a stable internet connection before starting the test.</li>
                    <li>2. The test is timed, and the countdown will begin once you start.</li>
                    <li>3. You cannot pause or restart the test once it has begun.</li>
                    <li>4. Each question has four options, and only one is correct.</li>
                    <li>5. Click on an answer to select it. You can change your answer before submitting.</li>
                    <li>6. Use the Next and Previous buttons to navigate between questions.</li>
                    <li>7. You can flag questions for review by clicking the "Flag Question" button below each question. Flagged questions will appear in red in the navigation bar, making it easy to revisit them later.</li>
                    <li>8. Do not refresh or close the browser tab, as this may result in losing your progress.</li>
                    <li>9. Once the test is submitted, you will see your test results.</li>
                  </ol>

                </div>
              </div>
            </div>
          </div>
          <div v-if="test == 'practice'" class="admin-courses-tab-content">
            <div class="tab-content">
              <div class="tab-pane fade show active" id="tab1">

                <div class="padding-top-50">

                  <p class="question">You are about to start a Practice test!</p>
                  <p class="question">Please read the information below carefully before clicking start button - </p>

                  <ol class="test-instructions">
                    <li>1. Ensure you have a stable internet connection before starting the test.</li>
                    <li>2. Practice test is not timed.</li>
                    <li>3. You cannot pause or restart the test once it has begun.</li>
                    <li>4. Each question has four options, and only one is correct.</li>
                    <li>5. Click on an answer to select it. You can change your answer before submitting.</li>
                    <li>6. Use the Next and Previous buttons to navigate between questions.</li>
                    <li>7. You can flag questions for review by clicking the "Flag Question" button below each question. Flagged questions will appear in red in the navigation bar, making it easy to revisit them later.</li>
                    <li>8. Do not refresh or close the browser tab, as this may result in losing your progress.</li>
                    <li>9. Once the test is submitted, you will see your test results.</li>
                  </ol>

                </div>
              </div>
            </div>
          </div>
          <!-- Admin Courses Tab Content End -->

          <!-- <div class="message-form">
            <div class="message-input">
              <div class="message-btn button-width">
                <router-link class="btn btn-primary btn-hover-dark font-weight-bold font-size-20" to="mock-test">Start {{test_type}} Test</router-link>
              </div>
            </div>
          </div> -->

        </div>
        <!-- Graph Top End -->

      </div>
    </div>
  </div>
  <!-- Page Content Wrapper End -->

</template>

<script>
export default {
  name: 'TestStartScreen',
  props: {
    test: {
      type: String,
      required: true,
    },
  },
}
</script>
